var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-container"},[_c('iframe',{attrs:{"src":_vm.htmlUrl,"frameborder":"0","allowfullscreen":"","id":"myIframe"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }